import styles from './StopIndex.module.scss';

export type StopIndexProps = Record<string, never>;

const StopIndex = (): JSX.Element => {
  return <div className={styles.main} dangerouslySetInnerHTML={{ __html: '<!-- stopindex -->' }} />;
};

export default StopIndex;
